<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<h2 mat-dialog-title>{{'assign.upload-or-enter-code-dialog.title' | translate}}</h2>

<mat-dialog-content class="main-content">
    <form class="request-code-form" [formGroup]="form">
        <mat-form-field subscriptSizing="dynamic" appearance="outline" class="request-code-form-field"
                floatLabel="always">
            <mat-label>{{'assign.upload-or-enter-code-dialog.code-label' | translate}}</mat-label>
            <textarea id="code-input" #requestCodeText matInput class="request-code" formControlName="requestCode"
                cdkTextareaAutosize cdkAutosizeMinRows="4" cdkAutosizeMaxRows="10">
            </textarea>
            <button matSuffix mat-icon-button *ngIf="requestCodeText.value.length > 0"
                    (click)="clearText(requestCodeText, $event)" class="input-icon">
                <i class="mdi mdi-close close-icon"></i>
            </button>
            <button matSuffix mat-icon-button type="button"
                    (click)="fileUploadInput.click()" class="input-icon">
                <i class="mdi mdi-dots-horizontal"></i>
            </button>
        </mat-form-field>
    </form>
    <div>
        <input #fileUploadInput accept=".req" type="file" id="fde-file-input" style="display: none;" (change)="onUploadClick($event)" />
    </div>
</mat-dialog-content>

<div mat-dialog-actions>
    <button id="cancel-code" mat-raised-button type="button" (click)="onCancelClick()">{{'CANCEL' | translate}}</button>
    <button id="save-code" mat-raised-button type="button" color="primary" (click)="onSaveClick()" [disabled]="!form.valid">{{'SAVE' | translate}}</button>
</div>
